import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";

const HeroCosmic = () => {
  const scrollToWork = () => {
    const element = document.getElementById("work");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen bg-black pt-20 overflow-hidden">
      {/* Cosmic gradient orbs */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Top left gradient */}
        <div
          className="absolute -top-1/2 -left-1/4 w-[800px] h-[800px] rounded-full opacity-20"
          style={{
            background:
              "radial-gradient(circle, rgba(255, 100, 150, 0.4) 0%, transparent 70%)",
          }}
        />
        {/* Bottom right gradient */}
        <div
          className="absolute -bottom-1/2 -right-1/4 w-[900px] h-[900px] rounded-full opacity-20"
          style={{
            background:
              "radial-gradient(circle, rgba(100, 150, 255, 0.4) 0%, transparent 70%)",
          }}
        />
        {/* Center gradient */}
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full opacity-15"
          style={{
            background:
              "radial-gradient(circle, rgba(255, 200, 100, 0.3) 0%, transparent 70%)",
          }}
        />
      </div>

      {/* Stars background */}
      <div className="absolute inset-0 opacity-40">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.4) 1px, transparent 0)`,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      <div className="relative z-10 min-h-[calc(100vh-80px)] flex items-center">
        <div className="w-full px-[7.6923%] py-20">
          <div className="max-w-[1400px] mx-auto">
            {/* Content centered */}
            <div className="max-w-4xl mx-auto text-center space-y-8">
              <div className="space-y-6">
                <h1 className="text-5xl md:text-6xl lg:text-[72px] font-semibold leading-[1.1] tracking-tight text-white">
                  Get yourself a website that actually works.
                </h1>
                <p className="text-xl md:text-2xl text-white text-opacity-85 leading-relaxed max-w-3xl mx-auto">
                  We're a small, experienced team building fast, reliable
                  websites for local businesses.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center">
                <a
                  href="mailto:hello@frontroom.website"
                  className="bg-[#00FFD1] text-black px-6 py-4 text-lg font-medium transition-all duration-400 hover:bg-white hover:scale-[1.02] flex items-center justify-center gap-3 min-h-14"
                >
                  <span>hello@frontroom.website</span>
                  <ArrowRight size={22} />
                </a>
                <button
                  onClick={scrollToWork}
                  className="bg-white bg-opacity-10 text-white px-6 py-4 text-lg font-medium transition-all duration-400 hover:bg-white hover:text-black flex items-center justify-center gap-3 min-h-14 backdrop-blur-sm"
                >
                  See our work
                  <ArrowDown size={22} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown size={32} className="text-white text-opacity-40" />
      </div>
    </section>
  );
};

export default HeroCosmic;
